import { OnInit, OnDestroy, Component, HostListener, Optional, Inject } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-OrderStatusFilter',
    templateUrl: './dojo-OrderStatusFilter.component.html'
})
export class DojoOrderStatusFilterComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    params: any;
    OrderStatusFilterParams: any;
    OrderDownloadLinkParams: any;
    ismobile: boolean = false;
    constructor(private contextService: IContextService,
                private router: Router,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService,
                @Optional() @Inject('AppSettings') appSettings: any) {
                    if (appSettings.deviceType === 'mobile') {
                        this.ismobile = true;
                    }
                }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getOrderStatusFilterDownload();
        });
    }
    ngAfterViewInit(): void {
        if (this.ismobile) {
            document.getElementById('orderStatus-filter').style.display = 'none';
        }
    }
    handleOrderstatusFilter(event: any) {
        if (event.checked) {
            document.getElementById('orderStatus-filter').style.display = 'block';
        } else {
            document.getElementById('orderStatus-filter').style.display = 'none';
        }
    }
    ngOnDestroy(): void {
        console.log('In DojoOrderStatusFilterComponent destroy method');
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.destroyOrderStatusFilter();
        }
    }
    renderDojoWidget(OrderStatusFilterDojoParams: any, OrderDownloadLinkDojoParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderOrderStatusFilter(this.inputValue, OrderStatusFilterDojoParams, OrderDownloadLinkDojoParams);
        }
    }

    getOrderStatusFilterDownload() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'ordersFilter').subscribe(
                resp => {
                    console.log('Retrived common REST order filter params : ', resp.response);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        resp.response.modAPIUrl = 'https://api-netxselect.wsodqa.com';
                        this.OrderStatusFilterParams = resp.response;
                        this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'ordersLinkData').subscribe(
                            res => {
                                console.log('Retrived common REST Orders Download params : ', res.response);
                                if (res.response) {
                                    res.response.downloadUrl = this.nxiRestService.serviceUrl + res.response.downloadUrl;
                                    this.OrderDownloadLinkParams = res.response;
                                    this.renderDojoWidget(this.OrderStatusFilterParams, this.OrderDownloadLinkParams);
                                }
                            }
                        );
                    }
                }
            );
        }
    }
   // used to handle click event on submit button
   @HostListener('click', ['$event.target'])
   onClick(btn) {
       console.log('button', btn);
   }
}
